import auth from 'src/router/middleware/authentification/auth.js'
import timetableFeedback from 'src/router/middleware/timetable/timetableFeedback.js'
import timetableEntity from 'src/router/middleware/timetable/timetableEntity.js'
import timetableCourseDetailsQuery from 'src/router/middleware/timetable/timetableCourseDetailsQuery.js'
import classbookRedirect from 'src/router/middleware/classbook/classbookRedirect.js'
import timeGrid from 'src/router/middleware/timeGrid/timeGrid.js'

const TimetablePage = () => import('src/views/Timetable/TimetablePage.vue')
const CourseSelectionWrapper = () => import('src/views/Timetable/CourseSelection/CourseSelectionWrapper.vue')
const CourseSelectionStart = () => import('src/views/Timetable/CourseSelection/CourseSelectionStart.vue')
const CourseSelectionOverlapping = () => import('src/views/Timetable/CourseSelection/CourseSelectionOverlapping.vue')
const CourseSelectionSingleLessons = () => import('src/views/Timetable/CourseSelection/CourseSelectionSingleLessons.vue')
const CourseSelectionLastCheck = () => import('src/views/Timetable/CourseSelection/CourseSelectionLastCheck.vue')
const CourseSelectionFinished = () => import('src/views/Timetable/CourseSelection/CourseSelectionFinished.vue')
const FeedbackDialogWrapper = () => import('src/views/Timetable/Feedback/FeedbackDialogWrapper.vue')
const NoTimetable = () => import('src/views/Timetable/TimetableEmptyPage.vue')
const TimetableLoading = () => import('src/views/Timetable/TimetableLoading.vue')
const TimetableCourseDetails = () => import('src/views/Timetable/TimetableCourseDetails.vue')
const AbsenceOverview = () => import('src/views/Timetable/Absence/AbsenceOverview.vue')
const AbsenceUser = () => import('src/views/Timetable/Absence/AbsenceUser.vue')
const UserNotices = () => import('src/views/Timetable/Notice/NoticeUser.vue')
const FeedbackDialogStart = () => import('src/views/Timetable/Feedback/FeedbackDialogStart.vue')
const FeedbackDialogSolution = () => import('src/views/Timetable/Feedback/FeedbackDialogSolution.vue')
const FeedbackDialogSendFeedback = () => import('src/views/Timetable/Feedback/FeedbackDialogSendFeedback.vue')
const FeedbackDialogSelected = () => import('src/views/Timetable/Feedback/FeedbackDialogSelected.vue')
const FeedbackDialogResponse = () => import('src/views/Timetable/Feedback/FeedbackDialogResponse.vue')
const FeedbackDialogPredictedSolution = () => import('src/views/Timetable/Feedback/FeedbackDialogPredictedSolution.vue')
const FeedbackDialogConfirm = () => import('src/views/Timetable/Feedback/FeedbackDialogConfirm.vue')
const FeedbackDialogCourses = () => import('src/views/Timetable/Feedback/FeedbackDialogCourses.vue')
const FeedbackDialogWrongTimetable = () => import('src/views/Timetable/Feedback/FeedbackDialogWrongTimetable.vue')

export default [
  {
    path: '/timetable',
    component: TimetableLoading,
    name: 'timetable-middle',
    meta: {
      layout: 'sdui',
      middleware: [auth, timetableEntity],
      group: 'timetable',
      enableChildSwitch: true,
      headerText: 'global.headers.timetable',
      noSchoolHeader: 'global.headers.weekly_schedule',
      enableSwReload: true
    }
  },
  {
    path: '/timetable/:entity/:id',
    component: TimetablePage,
    name: 'timetable',
    meta: {
      layout: 'sdui',
      middleware: [auth, timeGrid, timetableEntity],
      group: 'timetable',
      enableChildSwitch: true,
      headerText: 'global.headers.timetable',
      noSchoolHeader: 'global.headers.weekly_schedule',
      preventScrollTop: true
    },
    children: [
      {
        path: 'lesson/:lessonId',
        name: 'course-details',
        component: TimetableCourseDetails,
        meta: {
          layout: 'sdui',
          middleware: [auth, timeGrid, timetableEntity, timetableCourseDetailsQuery],
          group: 'timetable',
          enableChildSwitch: true,
          headerText: 'global.headers.timetable',
          noSchoolHeader: 'global.headers.weekly_schedule',
          preventAutomaticScreenReaderFocus: true
        }
      },
      {
        path: 'lesson/:lessonId/entry/:entryId/absences',
        component: AbsenceOverview,
        name: 'classbook-absences',
        meta: {
          middleware: [auth, timeGrid, timetableEntity, classbookRedirect],
          layout: 'sdui',
          group: 'timetable',
          enableChildSwitch: true,
          headerText: 'global.headers.timetable',
          noSchoolHeader: 'global.headers.weekly_schedule',
          mobileView: true
        }
      },
      {
        path: 'lesson/:lessonId/entry/:entryId/absences/user/:userId',
        component: AbsenceUser,
        name: 'classbook-user-absences-overview',
        meta: {
          middleware: [auth, classbookRedirect],
          layout: 'sdui',
          group: 'timetable',
          enableChildSwitch: true,
          headerText: 'global.headers.timetable',
          noSchoolHeader: 'global.headers.weekly_schedule',
          mobileView: true
        }
      },
      {
        path: 'lesson/:lessonId/entry/:entryId/notices/user/:userId',
        component: UserNotices,
        name: 'classbook-user-notices-overview',
        meta: {
          middleware: [auth, classbookRedirect],
          layout: 'sdui',
          group: 'timetable',
          enableChildSwitch: true,
          headerText: 'global.headers.timetable',
          noSchoolHeader: 'global.headers.weekly_schedule',
          mobileView: true
        }
      }
    ]
  },
  // {
  //   path: '/timetable/:entity?/:id?/:lessonId?',
  //   component: Index,
  //   name: 'timetable',
  //   meta: {
  //     middleware: [ auth, timetableEntity],
  //     group: 'timetable',
  //     enableChildSwitch: true,
  //     headerText: 'Stundenplan'
  //   }
  // },
  {
    path: '/no-timetable/:id?/:entity?',
    component: NoTimetable,
    name: 'timetableMissing',
    meta: {
      layout: 'sdui',
      middleware: [auth, timetableEntity],
      group: 'timetable',
      enableChildSwitch: true,
      headerText: 'global.headers.timetable',
      noSchoolHeader: 'global.headers.weekly_schedule',
      enableSwReload: true
    }
  },
  {
    path: '/course-selection',
    component: CourseSelectionWrapper,
    children: [
      {
        path: 'start',
        component: CourseSelectionStart,
        name: 'CourseSelectionStart',
        meta: {
          middleware: [auth],
          group: 'timetable',
          transitionPoint: 1,
          headerText: 'global.headers.change_timetable'
        }
      },
      {
        path: 'step/:i',
        component: CourseSelectionOverlapping,
        name: 'CourseSelectionOverlapping',
        meta: {
          middleware: [auth],
          group: 'timetable',
          transitionPoint: 2,
          headerText: 'global.headers.change_timetable'
        }
      },
      {
        path: 'single-lessons',
        component: CourseSelectionSingleLessons,
        name: 'CourseSelectionSingleLessons',
        meta: {
          middleware: [auth],
          group: 'timetable',
          transitionPoint: 100,
          headerText: 'global.headers.change_timetable'
        }
      },
      {
        path: 'last-check',
        component: CourseSelectionLastCheck,
        name: 'CourseSelectionLastCheck',
        meta: {
          middleware: [auth],
          group: 'timetable',
          transitionPoint: 102,
          headerText: 'global.headers.change_timetable'
        }
      },
      {
        path: 'finished',
        component: CourseSelectionFinished,
        name: 'CourseSelectionFinished',
        meta: {
          middleware: [auth],
          group: 'timetable',
          transitionPoint: 103,
          headerText: 'global.headers.change_timetable'
        }
      }
    ]
  },
  {
    path: '/feedback/dialog/:userId',
    component: FeedbackDialogWrapper,
    name: 'feedback-wrapper',
    meta: {
      middleware: [auth, timetableFeedback],
      group: 'feedback',
      progress: 1,
      headerText: 'global.headers.help'
    },
    children: [
      {
        path: 'start/:unit?',
        component: FeedbackDialogStart,
        name: 'feedback-dialog-start',
        meta: {
          middleware: [auth, timetableFeedback],
          group: 'feedback',
          progress: 1,
          transitionPoint: 1,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'solution',
        component: FeedbackDialogSolution,
        name: 'feedback-dialog-solution',
        meta: {
          middleware: [auth, timetableFeedback],
          group: 'timetable',
          progress: 2,
          transitionPoint: 2,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'send-feedback',
        component: FeedbackDialogSendFeedback,
        name: 'feedback-dialog-send-feedback',
        meta: {
          middleware: [auth, timetableFeedback],
          group: 'feedback',
          progress: 3,
          transitionPoint: 3,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'selected',
        component: FeedbackDialogSelected,
        name: 'feedback-dialog-selected',
        meta: {
          middleware: [auth],
          group: 'feedback',
          progress: 2,
          transitionPoint: 2,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'response',
        component: FeedbackDialogResponse,
        name: 'feedback-dialog-response',
        meta: {
          middleware: [auth],
          group: 'feedback',
          progress: 4,
          transitionPoint: 4,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'predicted-solution',
        component: FeedbackDialogPredictedSolution,
        name: 'feedback-dialog-predicted-solution',
        meta: {
          middleware: [auth, timetableFeedback],
          group: 'feedback',
          progress: 2,
          transitionPoint: 2,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'wrong-timetable',
        component: FeedbackDialogWrongTimetable,
        name: 'feedback-dialog-wrong-timetable',
        meta: {
          middleware: [auth, timetableFeedback],
          group: 'feedback',
          progress: 2,
          transitionPoint: 2,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'confirm',
        component: FeedbackDialogConfirm,
        name: 'feedback-dialog-confirm',
        meta: {
          middleware: [auth],
          group: 'feedback',
          progress: 4,
          transitionPoint: 4,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'courses',
        component: FeedbackDialogCourses,
        name: 'feedback-dialog-courses',
        meta: {
          middleware: [auth],
          group: 'feedback',
          progress: 3,
          transitionPoint: 3,
          headerText: 'global.headers.help'
        }
      }
    ]
  }
]
